import { ZERO_UUID } from 'commons/constants/parse.js';

export const state = () => ({});

export const getSearch = (saved_search_uuid) => ({
    saved_search_uuid,
    workspace_uuid: ZERO_UUID,
    name: '',
    note: '',
    filters: [],
    content: [],
    previous_pages: {},
    next_page: [],
    total_hits: 0,
    tag_list: {},
    filter_tag_list: {},
});
